import React from 'react';
import Modal from 'utils/packages/Modal';
import { Button, ButtonGroup } from 'design-system';
import OnboardingHowFreeTrialWorksWarningModalContent from './OnboardingHowFreeTrialWorksWarningModalContent';
export const OnboardingHowFreeTrialWorksWarningModal = {
    show: (selectedTier, shouldSeePremiumTrialScreen, containerStyles, onConfirm, onDismiss, showCompareTable, maxHeight, showNumbers, showUserDeck) => {
        Modal.show(<OnboardingHowFreeTrialWorksWarningModalContent tier={selectedTier} showNumbers={showNumbers} showUserDeck={showUserDeck} showCompareTable={showCompareTable} shouldSeePremiumTrialScreen={shouldSeePremiumTrialScreen} onConfirm={() => {
                Modal.hide(() => {
                    onConfirm();
                }, { top: true });
            }} onDismiss={() => {
                Modal.hide(() => {
                    onDismiss?.();
                }, { top: true });
            }}/>, {
            title: showUserDeck ? '' : 'Are you sure? 🧸',
            top: true,
            containerStyle: {
                paddingHorizontal: 0,
            },
            ...(showCompareTable &&
                !showUserDeck &&
                maxHeight && {
                scrollable: {
                    maxHeight,
                    outsideContent: (<ButtonGroup style={containerStyles}>
                  <Button brandReversed title="Yes, I am sure" onPress={() => {
                            Modal.hide(() => {
                                onConfirm();
                            }, { top: true });
                        }}/>
                  <Button brand title="No, let me try" onPress={() => {
                            Modal.hide(() => {
                                onDismiss?.();
                            }, { top: true });
                        }}/>
                </ButtonGroup>),
                },
            }),
        });
    },
    hide: () => {
        Modal.hide(undefined, { top: true });
    },
};
